import { useCallback, useEffect, useRef, useState } from "react";
import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import UpdateFeed from "./components/UpdateFeed";
import EntryLines from "./components/EntryLines";
import TrendingTopics from "./components/TrendingTopics";
import GuideSteps from "./components/GuideSteps";
import SafetyNotice from "./components/SafetyNotice";
import FaqSection from "./components/FaqSection";
import CommunityBoard from "./components/CommunityBoard";
import SubscribeSection from "./components/SubscribeSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const notify = useCallback((message: string) => {
    setToast(message);
  }, []);

  useEffect(() => {
    if (!toast) return undefined;
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setToast(null), 2600);
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [toast]);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <SiteNav notify={notify} />
      <main>
        <Hero notify={notify} />
        <Ticker />
        <UpdateFeed />
        <EntryLines notify={notify} />
        <TrendingTopics notify={notify} />
        <GuideSteps />
        <SafetyNotice />
        <FaqSection />
        <CommunityBoard notify={notify} />
        <SubscribeSection notify={notify} />
      </main>
      <SiteFooter />

      {toast ? (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] px-4 w-full max-w-md animate-fade-up">
          <div className="flex items-center gap-2.5 rounded-lg bg-foreground-950 px-4 py-3 shadow-lg">
            <i className="ri-checkbox-circle-line text-accent-400 text-lg shrink-0" />
            <span className="text-sm text-background-50 leading-snug">{toast}</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}